import NegotiationProposal, {
  NegotiationActionType,
  NegotiationProposalUserType
} from './NegotiationProposal';
import NegotiationState from '../constants/negotiationState';

export enum NegotiationStateShort {
  NO_NEGOTIATION = 'NO_NEGOTIATION',
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  ACCEPTED = 'ACCEPTED',
  FINAL_ASKING_PRICE = 'FINAL_ASKING_PRICE'
}

class NegotiationList {
  canAccept: boolean;

  canReject: boolean;

  canCounter: boolean;

  canStayFirm: boolean;

  negotiationState: NegotiationStateShort;

  proxyAmount?: null | number;

  topBid?: number;

  floorPrice?: null | number;

  proposals: NegotiationProposal[];

  constructor(
    canAccept: boolean,
    canReject: boolean,
    canCounter: boolean,
    canStayFirm: boolean,
    negotiationState: NegotiationStateShort,
    proxyAmount?: null | number,
    topBid?: number,
    floorPrice?: null | number,
    proposals: NegotiationProposal[]
  ) {
    this.canAccept = canAccept;
    this.canReject = canReject;
    this.canCounter = canCounter;
    this.canStayFirm = canStayFirm;
    this.negotiationState = negotiationState;
    this.proxyAmount = proxyAmount;
    this.topBid = topBid;
    this.floorPrice = floorPrice;
    this.proposals = proposals;
  }
}

export const getLatestProposal = negotiationList => {
  return negotiationList?.proposals?.slice(-1)[0] || null;
};

const getLastIndexWhere = (array, filter) => {
  if (array) {
    for (let i = array.length - 1; i >= 0; i -= 1) {
      if (filter(array[i])) {
        return i;
      }
    }
  }

  return -1;
};

export const getLatestProposalPrice = negotiationList => {
  const index = getLastIndexWhere(negotiationList?.proposals, proposal =>
    [
      NegotiationActionType.PROPOSAL,
      NegotiationActionType.FINAL_ASKING_PRICE
    ].includes(proposal?.actionType)
  );

  return index === -1 ? null : negotiationList?.proposals[index].price;
};

export const getNegotiationState = negotiationList => {
  switch (negotiationList?.negotiationState) {
    case NegotiationStateShort.NO_NEGOTIATION:
      return NegotiationState.NO_NEGOTIATION;
    case NegotiationStateShort.ACCEPTED:
      return NegotiationState.ACCEPTED;
    case NegotiationStateShort.REJECTED:
      return NegotiationState.DECLINED;
    case NegotiationStateShort.FINAL_ASKING_PRICE:
      return NegotiationState.FINAL_ASKING_PRICE;
    default:
  }

  const latestProposal = getLatestProposal(negotiationList);
  const countersExist = negotiationList?.proposals.length >= 2;

  switch (negotiationList?.negotiationState) {
    case NegotiationStateShort.IN_PROGRESS:
      if (latestProposal.recipient !== NegotiationProposalUserType.SELLER) {
        return countersExist
          ? NegotiationState.SELLER_COUNTER
          : NegotiationState.SELLER_OFFER;
      }
      if (latestProposal.stayFirm) {
        return NegotiationState.BUYER_FIRM;
      }
      return countersExist
        ? NegotiationState.BUYER_COUNTER
        : NegotiationState.BUYER_OFFER;
    default:
      return null;
  }
};

export default NegotiationList;
